<template>
  <StaffLayout section="Metrics" showHeader>
    <Loading v-if="isMetricsLoading" />
    <div v-else class="tab-group-container h-full w-full flex flex-col gap-4">
      <TabGroup>
        <TabList>
          <Tab v-slot="{ selected }">
            <button
              :class="[
                'w-full py-2 px-4 font-medium leading-5',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                selected
                  ? 'bg-blue-300 text-black shadow py-3'
                  : 'bg-gray-100 text-gray-800 hover:bg-blue-100  mb-1',
              ]"
            >
              Trends
            </button>
          </Tab>
          <Tab v-slot="{ selected }">
            <button
              :class="[
                'w-full py-2 px-4 font-medium leading-5',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                selected
                  ? 'bg-blue-300 text-black shadow py-3'
                  : 'bg-gray-100 text-gray-800 hover:bg-blue-100  mb-1',
              ]"
            >
              Local Counts
            </button>
          </Tab>
          <Tab v-slot="{ selected }">
            <button
              :class="[
                'w-full py-2 px-4 font-medium leading-5',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                selected
                  ? 'bg-blue-300 text-black shadow py-3'
                  : 'bg-gray-100 text-gray-800 hover:bg-blue-100  mb-1',
              ]"
            >
              User Research
            </button>
          </Tab>

          <Tab v-slot="{ selected }">
            <button
              :class="[
                'w-full py-2 px-4 font-medium leading-5',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                selected
                  ? 'bg-blue-300 text-black shadow py-3'
                  : 'bg-gray-100 text-gray-800 hover:bg-blue-100  mb-1',
              ]"
            >
              Website Metrics
            </button>
          </Tab>

          <Tab v-slot="{ selected }">
            <button
              :class="[
                'w-full py-2 px-4 font-medium leading-5',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2',
                selected
                  ? 'bg-blue-300 text-black shadow py-3'
                  : 'bg-gray-100 text-gray-800 hover:bg-blue-100  mb-1',
              ]"
            >
              Growth Dashboard
            </button>
          </Tab>
        </TabList>
        <TabPanels class="border border-blue-300 p-8 h-full">
          <TabPanel class="h-full">
            <div class="flex flex-col gap-4">
              <div class="text-lg font-semibold">Trends</div>
              <div class="text-sm text-gray-500">
                This is a general overview of the metrics for the last 30 days.
              </div>
            </div>
            <iframe
              width="100%"
              height="100%"
              frameborder="0"
              allowfullscreen
              src="https://us.posthog.com/embedded/6U0l7Cf4R5d1SrARRTkjvGSfBkNkkg"
            ></iframe>
          </TabPanel>

          <TabPanel class="h-full">
            <div class="flex flex-col gap-4">
              <div class="text-lg font-semibold">Local Metrics counts</div>
              <div class="text-sm text-gray-500">
                This is a general overview of the metrics for the last 30 days. Select a
                timeframe to view counts.
              </div>

              <BaseSelect
                class="text-sm"
                :options="timeFrameOptions"
                :defaultOption="null"
                defaultText="Time Frame"
                v-model="selectedTimeFrame"
              />

              <div
                class="flex"
                v-if="
                  metricResults != null &&
                  previousPeriodResults != null &&
                  metricsDifference != null
                "
              >
                <div class="basis-1/3 text-center">
                  <div>Unique users</div>
                  <div
                    :class="
                      metricsDifference.uniqueUsers != 0
                        ? metricsDifference.uniqueUsers > 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.uniqueUsers }} ({{
                      (metricsDifference.uniqueUsers > -1 ? "+" : "") +
                      metricsDifference.uniqueUsers
                    }})
                  </div>
                </div>
                <div class="basis-1/3 text-center">
                  <div>Sessions</div>
                  <div
                    :class="
                      metricsDifference.sessions != 0
                        ? metricsDifference.sessions > 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.sessions }} ({{
                      (metricsDifference.sessions > -1 ? "+" : "") +
                      metricsDifference.sessions
                    }})
                  </div>
                </div>
                <div class="basis-1/3 text-center">
                  <div>Page Views</div>
                  <div
                    :class="
                      metricsDifference.pageViews != 0
                        ? metricsDifference.pageViews > 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.pageViews }} ({{
                      (metricsDifference.pageViews > -1 ? "+" : "") +
                      metricsDifference.pageViews
                    }})
                  </div>
                </div>
                <div class="basis-1/3 text-center">
                  <div>Rage Clicks</div>
                  <div
                    :class="
                      metricsDifference.rageClicks != 0
                        ? metricsDifference.rageClicks < 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.rageClicks }} ({{
                      (metricsDifference.rageClicks > -1 ? "+" : "") +
                      metricsDifference.rageClicks
                    }})
                  </div>
                </div>
                <div class="basis-1/3 text-center">
                  <div>Respond Views</div>
                  <div
                    :class="
                      metricsDifference.respondViews != 0
                        ? metricsDifference.respondViews > 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.respondViews }} ({{
                      (metricsDifference.respondViews > -1 ? "+" : "") +
                      metricsDifference.respondViews
                    }})
                  </div>
                </div>
                <div class="basis-1/3 text-center">
                  <div>Videos Views</div>
                  <div
                    :class="
                      metricsDifference.videosEnded != 0
                        ? metricsDifference.videosEnded > 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.videosEnded }} ({{
                      (metricsDifference.videosEnded > -1 ? "+" : "") +
                      metricsDifference.videosEnded
                    }})
                  </div>
                </div>
                <div class="basis-1/3 text-center">
                  <div>Questions Answered</div>
                  <div
                    :class="
                      metricsDifference.questionsAnswered != 0
                        ? metricsDifference.questionsAnswered > 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.questionsAnswered }} ({{
                      (metricsDifference.questionsAnswered > -1 ? "+" : "") +
                      metricsDifference.questionsAnswered
                    }})
                  </div>
                </div>
                <div class="basis-1/3 text-center">
                  <div>Tests Completed</div>
                  <div
                    :class="
                      metricsDifference.testsCompleted != 0
                        ? metricsDifference.testsCompleted > 0
                          ? 'text-green-500'
                          : 'text-red-500'
                        : ''
                    "
                  >
                    {{ metricResults.testsCompleted }} ({{
                      (metricsDifference.testsCompleted > -1 ? "+" : "") +
                      metricsDifference.testsCompleted
                    }})
                  </div>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel class="h-full">
            <div class="flex flex-col gap-4">
              <div class="text-lg font-semibold">User Research</div>
            </div>
            <iframe
              width="100%"
              height="100%"
              frameborder="0"
              allowfullscreen
              src="https://us.posthog.com/embedded/rJlxAGrXjECKzyy7kKY6SIn2cVintA"
            ></iframe>
          </TabPanel>

          <TabPanel class="h-full">
            <div class="flex flex-col gap-4">
              <div class="text-lg font-semibold">Website Metrics</div>
            </div>

            <iframe
              width="100%"
              height="100%"
              frameborder="0"
              allowfullscreen
              src="https://us.posthog.com/embedded/Vivm-5SgY9kDePTc2c2q_nkFzlFAhg"
            ></iframe>
          </TabPanel>

          <TabPanel class="h-full">
            <div class="flex flex-col gap-4">
              <div class="text-lg font-semibold">Growth Dashboard</div>
            </div>

            <iframe
              width="100%"
              height="100%"
              frameborder="0"
              allowfullscreen
              src="https://us.posthog.com/embedded/y7S6E4JncBIgaixoTPZx0IN3k0VdUg"
            ></iframe>
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  </StaffLayout>
</template>

<script setup lang="ts">
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from "@headlessui/vue";

import { getGlobalMetrics, MetricsReturnData } from "../../helpers/metrics";
import { timeFrameOptions } from "../../helpers";

const isMetricsLoading = ref(false);

const selectedTimeFrame: Ref<number | null> = ref(null);
const metricResults = ref(null as MetricsReturnData);
const previousPeriodResults = ref(null as MetricsReturnData);

const metricsDifference = computed(() => {
  if (metricResults.value != null && previousPeriodResults.value != null)
    return {
      uniqueUsers:
        metricResults.value.uniqueUsers - previousPeriodResults.value.uniqueUsers,
      pageViews: metricResults.value.pageViews - previousPeriodResults.value.pageViews,
      sessions: metricResults.value.sessions - previousPeriodResults.value.sessions,
      rageClicks: metricResults.value.rageClicks - previousPeriodResults.value.rageClicks,
      respondViews:
        metricResults.value.respondViews - previousPeriodResults.value.respondViews,
      videosEnded:
        metricResults.value.videosEnded - previousPeriodResults.value.videosEnded,
      questionsAnswered:
        metricResults.value.questionsAnswered -
        previousPeriodResults.value.questionsAnswered,
      testsCompleted:
        metricResults.value.testsCompleted - previousPeriodResults.value.testsCompleted,
    } as MetricsReturnData;

  return null;
});

onMounted(async () => await loadData());
watch(selectedTimeFrame, loadData);

async function loadData() {
  await getMetricData();
}

async function getMetricData() {
  if (selectedTimeFrame.value != null) {
    isMetricsLoading.value = true;

    let currentPeriodFromDate = new Date(Date.now());
    currentPeriodFromDate.setDate(
      currentPeriodFromDate.getDate() - selectedTimeFrame.value
    );

    let previousPeriodFromDate = new Date(Date.now());
    previousPeriodFromDate.setDate(
      previousPeriodFromDate.getDate() - selectedTimeFrame.value * 2
    );

    await Promise.all([
      getGlobalMetrics(currentPeriodFromDate, new Date(Date.now())),
      getGlobalMetrics(previousPeriodFromDate, currentPeriodFromDate),
    ]).then((allResults) => {
      metricResults.value = allResults[0];
      previousPeriodResults.value = allResults[1];
      isMetricsLoading.value = false;
    });
  }
}
</script>
